<template>
  <div id="biaozhu-wrap">
    <div style="display: none">
      <div ref="lywindow">
        <slot name="window"></slot>
      </div>
    </div>
    <div id="biaozhu"></div>
  </div>
</template>
<script>
var map;
var satelliteLayer;
//创建右键菜单
var contextMenu;
var contextMenuPositon; //右键
var markers = [];
var infoWindow;
var trafficLayer;
var mouseTool;
var ruleTool;
var myisToCenter = true; //是否移动到中心

export default {
  inject: ["reload"],

  data() {
    return {
      rightClickPoint: {},
      rightFenceCenter: {},
      rightLineCenter: {},
      isLock: true,
    };
  },
  methods: {
    //渲染车辆到地图
    showGpsPoints(data_info) {
      console.log('ditushuaxin',data_info)
      var that = this;
      map.remove(markers);
      markers = [];
      if (data_info.length == 0) {
        map.setZoom(5);
      }
      var baseSrc = this.axios.platConfig.fileUri + "mapicon/";
      for (var i = 0, marker; i < data_info.length; i++) {
        var direction = 1;
        var angle = data_info[i].directionDegree;
        if (data_info[i].icon.indexOf("001") != -1) {
          angle = 0;
        }
        if (data_info[i].icon.indexOf("002") != -1) {
          direction = data_info[i].direction;
        }
        var imgsrc =
          baseSrc +
          data_info[i].icon +
          "/" +
          data_info[i].realTimeStatus +
          "/" +
          //data_info[i].direction +
          direction +
          ".gif";
        var icon = new AMap.Icon({
          size: new AMap.Size(26, 26), // 图标尺寸
          image: imgsrc, // Icon的图像
          imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(26, 26), // 根据所设置的大小拉伸或压缩图片
        });

        // 创建覆盖物群组，并将 marker 传给 OverlayGroup
        marker = new AMap.Marker({
          map: map,
          position: [data_info[i].locateLng, data_info[i].locateLat],
          //icon: icon,

          offset: new AMap.Pixel(-13, -13),
          extData: data_info[i],
          zIndex: 1000,
          content:
            "<div class='lymapicon'><img style='transform:rotate(" +
            angle +
            "deg);' src='" +
            imgsrc +
            "'/>" +
            "<p>" +
            data_info[i].name +
            "</p>" +
            (data_info[i].alarmStatus == 0
              ? ""
              : "<span class='alarmNow'>报警</span>") +
            "</div>",
          // offset: new AMap.Pixel(0, 0)
        });
        //marker.content = components[i].$el;
        //marker.content = '1111111';
        /* marker.setLabel({
          content:
            // "<div style='transform:rotate(-"+data_info[i].directionDegree+"deg);transform-origin: 0 0;background:#333'>" +
            "<div>" +
            (data_info[i].alarmStatus == 0
              ? data_info[i].name
              : "<span class='alarmNow'>报警</span>" + data_info[i].name) +
            "</div>",
          offset: new AMap.Pixel(30, 5),
        }); */
        marker.on("click", markerClick);
        marker.on("rightclick", markerRightClick);

        if (myisToCenter && i == data_info.length - 1) {
          marker.emit("click", { target: marker });
        }

        markers.push(marker);
      }

      function markerRightClick(e) {
        contextMenu.open(map, e.lnglat);
        contextMenuPositon = e.target.getPosition();
      }

      function markerClick(e) {
        //console.log(e.target.getzIndex())

        that.showWindow(e.target.getExtData())
      }
      if (data_info.length == 0) {
        infoWindow.close();
        return;
      }
      // map.setFitView();
      if (myisToCenter || this.isLock) {
        var last = data_info[data_info.length - 1];
        map.panTo([last.locateLng, last.locateLat]);
        map.setZoom(18);
      }
      //自动推送的时候寻找当前点击的车
      for (let x = 0; x < data_info.length; x++) {

        if (
          infoWindow.getIsOpen() &&
          data_info[x].deviceId == that.dataWindow.deviceId
        ) {

          that.showWindow(data_info[x])
        }
      }
      //infoWindow.on("close", alert('关闭'));
    },
    showWindow(data,bool) {
      this.dataWindow = data;
      if (this.isLock||bool) {
        map.panTo([
          data.locateLng,
          data.locateLat,
        ]);
      }

      this.$emit("dataWindow", data);
      var ttt = document.getElementById("infoWindow");
      infoWindow.setContent(ttt);
      infoWindow.open(map, [
        data.locateLng,
        data.locateLat,
      ]);
    },
    //初始化高德地图
    gMap() {
      //getZoom();
      //getCenter();
      map = new AMap.Map("biaozhu", {
        resizeEnable: true,
        defaultCursor: "",
      });

      // 同时引入工具条插件，比例尺插件和鹰眼插件
      AMap.plugin(
        [
          "AMap.ToolBar",
          "AMap.Scale",
          "AMap.OverView",
          "AMap.MapType",
          "AMap.Geolocation",
        ],
        function () {
          // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
          map.addControl(
            new AMap.ToolBar({
              position: "RT",
              ruler: false,
            })
          );

          // 在图面添加比例尺控件，展示地图在当前层级和纬度下的比例尺
          map.addControl(
            new AMap.Scale({
              position: "RB",
            })
          );

          //在图面添加鹰眼控件，在地图右下角显示地图的缩略图
          //map.addControl(new AMap.OverView({ isOpen: true }));

          //在图面添加类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
          //map.addControl(new AMap.MapType());

          //在图面添加定位控件，用来获取和展示用户主机所在的经纬度位置
          //map.addControl(new AMap.Geolocation());
        }
      );
      mouseTool = new AMap.MouseTool(map);
      ruleTool = new AMap.MouseTool(map);
      var that = this;
      map.on("complete", function (ev) {
        that.utils.setMap(map);
        infoWindow = new AMap.InfoWindow({
          offset: new AMap.Pixel(0, -14),
          showShadow: true,
          closeWhenClickMap: false,
          autoMove: false, //是否自动移动到视野范围
        });
        satelliteLayer = new AMap.TileLayer.Satellite();
        trafficLayer = new AMap.TileLayer.Traffic({
          zIndex: 10,
        });
      });
    },
    //区域查车
    areaCar(t) {
      if (t) {
        mouseTool.rectangle({
          fillColor: "#00b0ff",
          strokeColor: "#80d8ff",
          //同Polygon的Option设置
        });
        map.setDefaultCursor("crosshair");
        var that = this;
        mouseTool.on("draw", function (event) {
          // event.obj 为绘制出来的覆盖物对象
          var path = event.obj.getPath(); //取得绘制的多边形的每一个点坐标
          var pts = [];
          for (let i = 0; i < path.length; i++) {
           
            var obj = {
              x: path[i].lng,
              y: path[i].lat,
            };
            pts.push(obj);
          }
          that.$emit("areaCar", pts);
        });
      } else {
        map.setDefaultCursor("");
        mouseTool.close(true);
      }
    },
    //区域查车清除
    clearFence() {
      var polyArr = map.getAllOverlays("polygon");
      map.remove(polyArr);
    },
    //接收子组件传来的显示隐藏路况
    reLuKuang() {
      this.isLukuang = !this.isLukuang;
      trafficLayer.setMap(map); //路况用的
      if (this.isLukuang) {
        trafficLayer.show();
      } else {
        trafficLayer.hide();
      }
    },
    //接收子组件传来的切换卫星地图/普通地图
    reYun(t) {
      if (t) {
        map.add(satelliteLayer);
      } else {
        map.remove(satelliteLayer);
      }
    },
    lockCar(v) {
      this.isLock = v;
    },
    //点击围栏，将围栏渲染到地图
    showFence(v) {
      this.utils.showFences(map, v);
    },
    //单机路线规划，显然线路到地图
    showLineFun(v) {
      this.utils.showLines(map, v);
    },
    //点击标注点，渲染到地图
    showPoints(v) {
      this.utils.showPoints(map, v);
    },
    //将webskck的点转化到定位数据
    websockToLocate(data, m) {
      this.data_info = [];
      myisToCenter = m;
      if (data.length > 0) {
        this.showGpsPoints(data);
      } else {
        this.showGpsPoints([]);
      }
    },

    //右键操作地图
    rightClick() {
      var that = this;
      contextMenu = new AMap.ContextMenu();
      //右键添加Marker标记
      contextMenu.addItem(
        "新建标注点",
        function (e) {
          that.rightClickPoint = contextMenuPositon;
          //console.log(that.rightClickPoint);
        },
        0
      );
      contextMenu.addItem(
        "新建围栏",
        function (e) {
          that.rightFenceCenter = contextMenuPositon;
        },
        1
      );
      contextMenu.addItem(
        "新建线路",
        function (e) {
          that.rightLineCenter = contextMenuPositon;
        },
        1
      );
      contextMenu.removeItem("新建标注点", function () { });
      contextMenu.removeItem("新建围栏");
      //地图绑定鼠标右击事件——弹出右键菜单
      map.on("rightclick", function (e) {
        contextMenu.open(map, e.lnglat);
        contextMenuPositon = e.lnglat;
      });
    },
    //测量距离
    drawRule(type) {
      switch (type) {
        //距离
        case "rule": {
          ruleTool.rule({
            startMarkerOptions: {
              //可缺省
              icon: new AMap.Icon({
                size: new AMap.Size(19, 31), //图标大小
                imageSize: new AMap.Size(19, 31),
                image: "https://webapi.amap.com/theme/v1.3/markers/b/start.png",
              }),
            },
            endMarkerOptions: {
              //可缺省
              icon: new AMap.Icon({
                size: new AMap.Size(19, 31), //图标大小
                imageSize: new AMap.Size(19, 31),
                image: "https://webapi.amap.com/theme/v1.3/markers/b/end.png",
              }),
              offset: new AMap.Pixel(-9, -31),
            },
            midMarkerOptions: {
              //可缺省
              icon: new AMap.Icon({
                size: new AMap.Size(19, 31), //图标大小
                imageSize: new AMap.Size(19, 31),
                image: "https://webapi.amap.com/theme/v1.3/markers/b/mid.png",
              }),
              offset: new AMap.Pixel(-9, -31),
            },
            lineOptions: {
              //可缺省
              strokeStyle: "solid",
              strokeColor: "#FF33FF",
              strokeOpacity: 1,
              strokeWeight: 2,
            },
            //同 RangingTool 的 自定义 设置，缺省为默认样式
          });
          break;
        }
        //面积
        case "measureArea": {
          ruleTool.measureArea({
            strokeColor: "#80d8ff",
            fillColor: "#80d8ff",
            fillOpacity: 0.3,
            //同 Polygon 的 Option 设置
          });
          break;
        }
      }
    },
    //接收测距控件信息，控制测距/取消测距
    reCeju(t) {
      if (t) {
        map.setDefaultCursor("crosshair");
        this.drawRule("rule");
      } else {
        map.setDefaultCursor("");
        ruleTool.close(true); //关闭，并清除覆盖物
      }
    },

    reAdds(v) {
      map.panTo([v.x, v.y]);
      map.setZoom(17);
    },
    clearAdd() {
      this.utils.showPoints(map, []);
    },
  },
  mounted() {
    var kk;
    kk = setInterval(() => {
      if (AMap) {
        this.gMap();
        clearInterval(kk);

      }
    }, 200)
    //this.rightClick();
  },

  /* destroyed() {
    //alert('退出等位页面')
    this.$emit("leaveLocatePage", true);
    map && map.destroy();
  }, */
};
</script>

<style>
#biaozhu-wrap {
  height: 100%;
  width: 100%;
  position: relative;
}

#biaozhu {
  height: calc(100% - 0px);
  width: 100%;
}

#biaozhu-wrap .lymapicon {
  text-align: center;
  margin-left: -50px;
  width: 100px;
}

#biaozhu-wrap .lymapicon img {
  width: 30px;
}

#biaozhu-wrap .lymapicon p {
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/map/locate.vue